import { LitElement, html, css, classMap, utils } from '@hh/global.js'

class HHNewsletterModal extends LitElement {
  static properties = {
    id: {},
    open: {
      type: Boolean,
      reflect: true,
    },
    showSuccess: {
      type: Boolean,
      reflect: true,
    },
    disabled: {
      type: Boolean,
      reflect: true,
    },
    delayTime: {
      type: Number,
      reflect: true,
      attribute: 'delay-time',
    },
  }

  constructor() {
    super()

    this.open = false
    this.timeoutId = null

    this.focusTrapElement = this.querySelector('hh-focus-trap')
    this.focusTrapElement.setAttribute('active', this.open)

    this.formModal = this.querySelector('.js-newsletter-modal')
    this.thanksModal = this.querySelector('.js-newsletter-thanks-modal')
    this.thanksModal.style.display = 'none'

    this.showSuccess = false
    this.successButton = this.querySelector('.js-newsletter-success-button')
    this.successButton.addEventListener('click', this.close.bind(this))

    this.closeButtons = this.querySelectorAll('.js-newsletter-modal-close')
    this.closeButtons.forEach((button) => {
      button.addEventListener('click', this.close.bind(this))
    })
  }

  connectedCallback() {
    super.connectedCallback()

    this.open = false
    const modalState = utils.getCookie('modalState')
    const submissionStatus = localStorage.getItem('modalState')

    this.timeoutId = setTimeout(() => {
      this.open = (modalState === 'open' || modalState === null) && submissionStatus !== 'submitted'
      this.focusTrapElement.setAttribute('active', this.open)
      this.timeoutId = null
    }, (this.delayTime || 0) * 1000)

    window.addEventListener('keydown', this.handleKeyDown.bind(this))
    window.addEventListener(
      'profileModalSuccess',
      this.handleShowSuccess.bind(this)
    )
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }

    window.removeEventListener('keydown', this.handleKeyDown.bind(this))
    window.removeEventListener('profileModalSuccess', this.handleShowSuccess)
  }

  requestUpdate(name, oldValue) {
    return super.requestUpdate(name, oldValue)
  }

  handleKeyDown(event) {
    event?.key?.toUpperCase() === 'ESCAPE' && this.closeModal()
  }

  handleShowSuccess() {
    this.showSuccess = true
    this.formModal.style.display = 'none'
    this.formModal.setAttribute('tabIndex', '-1')
    this.thanksModal.style.display = 'flex'
    this.thanksModal.setAttribute('tabIndex', '0')

    localStorage.setItem('modalState', 'submitted')

    setTimeout(() => {
      this.closeModal()
      this.showSuccess = false
    }, 5000)
  }

  closeModal() {
    this.open = false
    this.focusTrapElement.setAttribute('active', this.open)

    utils.setCookie('modalState', 'closed')

    document.querySelector('html').classList.remove('overflow-hidden')
  }

  close(event) {
    if (event.type === 'click') {
      this.closeModal()
      return
    }
  }


  updated(changedProperties) {
    if (this.disabled) return

    if (changedProperties.has('open') && this.open) {
      HH.toggle(document.querySelector('html'), ['overflow-hidden'])
    }

    if (changedProperties.has('disabled')) {
      HH.toggle(document.querySelector('html'), ['overflow-hidden'])
    }
  }

  outsideClick(event) {
    const path = event.composedPath()

    if (
      event.target.id !== 'newsletter-modal-content' &&
      !path.some((el) => el.id === 'newsletter-modal-content')
    ) {
      this.close(event)
    }
  }

  render() {
    return this.disabled
      ? html``
      : html`<div
          class=${classMap({
        modal: true,
        isOpen: this.open && !this.disabled,
      })}
          @click="${this.outsideClick}"
          role="dialog"
          aria-modal="true"
          aria-label="Newsletter Modal"
        >
          <div
            class=${classMap({
        content: true,
        isThankyou: this.showSuccess,
      })}
            
            role="document"
            tabindex="0"
          >
            <slot></slot>
          </div>
        </div>`
  }

  static styles = css`
    .modal {
      width: 100%;
      height: 100vh;
      padding: 2rem 1rem;
      position: fixed;
      inset: 0;
      opacity: 0;
      background-color: rgba(0, 0, 0, 0.57);
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      visibility: hidden;
      transition: all 0.3s ease-in-out;
    }

    .modal::before {
      content: '';
      position: absolute;
      inset: 0;
      backdrop-filter: blur(0.25rem);
      -webkit-backdrop-filter: blur(0.25rem);
    }

    .modal.isOpen {
      opacity: 1;
      visibility: visible;
      z-index: 1000;
    }

    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 1rem;
      right: 1rem;
      height: calc(100vh - 80px);
      overflow: hidden auto;
      z-index: 100;
    }

    @media screen and (min-width: 750px) {
      .content {
        margin: 0 auto;
        max-width: var(--hh-max-width, 790px);
      }
      .content.isThankyou {
        max-width: var(--hh-max-width, 395px);
      }
    }

    ::slotted(*) {
      width: var(--hh-slotted-width, auto);
      height: var(--hh-slotted-height, auto);
      margin: var(--hh-slotted-margin);
    }
  `
}

customElements.define('hh-newsletter-modal', HHNewsletterModal)
